import React from "react";

type ImageProps = React.HTMLProps<HTMLImageElement> & React.ImgHTMLAttributes<HTMLImageElement> & { avatar?: boolean };

export default class Image extends React.Component<ImageProps> {
	render() {
		const { className, ...rest } = this.props;
		return <img {...rest} className={className} />;
	}
}
